import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { TelegramDto } from '../../dto/TelegramDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiChangeServiceTelegram = async (dto: TelegramDto) => {
  const params: IApiParams = {
    url: '/telegram/changeTelegramService.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
